module.exports = __webpack_public_path__ + "static/2025-nom-agency-year-v2-b7439553320c1ecfeaf0512b1ad7fc93.svg";